import { CHART_SERIES_PALETTE } from "@/shared/ui/chart/public";

/**
 * Observability 차트의 색·마크 규약이다. 렌더러에 의존하지 않고 CSS 변수 문자열만 다룬다.
 *
 * 값을 TS 리터럴로 두지 않는 이유는 다른 차트 화면과 같다. 테마 전환은 리렌더 없이 CSS 로만
 * 끝나야 한다. 그래야 선 색과 범례 스와치가 같은 프레임에 바뀐다.
 */

/**
 * 계열 슬롯이다. dataviz 검증기에서 라이트·다크 모든 항목을 통과한 비교 팔레트를 그대로 쓴다.
 * 그래서 세 화면(Evaluation 비교 · Data Dashboard · Observability)이 같은 색 체계를 가진다.
 *
 * 슬롯 번호는 **계열의 고정 순서**로 정한다. 세션 지표는 계약에 고정된 순서
 * (`active`·`idle in tx`·`waiting`)를 그대로 쓴다. pod 지표는 서버가 `pod_name` 오름차순으로 주는
 * 순서를 쓴다. 그래서 replica 수가 바뀌어도 남은 pod 의 색이 덜 바뀐다.
 */
export function seriesSlotColor(slot: number): string {
  return CHART_SERIES_PALETTE[slot % CHART_SERIES_PALETTE.length];
}

export const MARK = {
  /** 선 굵기다. */
  strokeWidth: 2,
  /** 축 눈금 글자 크기다. */
  tickFontSize: 11,
  /** 차트 높이(px)다. 카드 안의 네 차트가 같은 높이여야 세로로 비교할 수 있다. */
  height: 200,
} as const;
